import React from 'react'
import Layout from '../components/Layout/Layout'

export default function MockEssayDashboard() {
  return (
    <Layout title={'Essay Dashboard'}>
        <div>
      <h1>Essay Dashboard</h1>
    </div>
    </Layout>
    
  )
}
